import React from 'react';
import clsx from 'clsx';
import CheckIcon from '@mui/icons-material/Check';

type Props = {
  stepNumber?: number;
  title: string;
  description: string;
  completed?: boolean;
}

export default function SignatureStep({
  stepNumber,
  title,
  description,
  completed,
}: Props) {
  return (
    <div className="flex gap-4">
      <div className="w-8 h-8">
        <span className={clsx(
          'rounded-full w-8 h-8 flex items-center justify-center font-semibold mt-1.5',
          { 'bg-populate-green': completed },
          { 'bg-gray-400 text-white': !completed },
        )}
        >
          {completed ? (
            <CheckIcon className="text-white font-semibold" />
          ) : (
            stepNumber
          )}
        </span>
      </div>
      <div>
        <h2 className="text-lg font-semibold">{title}</h2>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
}
